export default {
  computed: {
    // this maps to loginSubGroups
    computedSelfSubGroupAccess() {
      return this.$store.getters['subGroupAccess'] || []
    },
    // function to return groups formatted for use in a dropdown.
    // this maps to:  groupsForDropdown
    computedSelfGroupOptions() {
      return this.computedSelfGroupsArray.map(g => {
        return { value: g.groupCk, text: g.groupName }
      })
    },
    // just regular old groups you display in a table
    // maps to:  groups
    computedSelfGroups() {
      return this.groupsFromUserRoleResponse(this.computedSelfSubGroupAccess) || [];
    },
    // this transform is here because of the OG devs insistence on storing
    // groups/subGroups in a hash instead of an array.  All this does is get you
    // an Array of groups.  We already have this.
    /**
     * @deprecated not needed as of GroupSelector
     */
    computedSelfGroupsArray() {
      return Object.values(this.computedSelfGroups).map(group => {
        group.group = `${group.groupName} - ${group.groupId}`
        return group
      })
    }
  },
  methods: {
    goToGroup(group) {
      this.$router.push({
        name: 'group',
        params: {
          groupId: group.groupId
        }
      }, () => {
        this.$store.dispatch('groupSelector/SET_CURRENT_TAB', '')
      })
    },

    goToSubGroup(subGroup) {
      this.$router.push({
        name: 'subgroup',
        params: {
          groupCk: subGroup.groupCk,
          subGroupCk: subGroup.subGroupCk
        }
      }, () => {
        this.$store.dispatch('groupSelector/SET_CURRENT_TAB', '')
      })
    },
    // this is just groups.
    /**
     * 
     * @param {Array} selfSubGroupAccess 
     * @returns Array of groups.
     * @deprecated as of GroupSelector
     */
    groupsFromUserRoleResponse(selfSubGroupAccess = []) {
      const groups = {}
      selfSubGroupAccess.forEach(sg => {
        if (!groups[sg.groupCk]) {
          groups[sg.groupCk] = {
            groupName: sg.groupName,
            groupCk: sg.groupCk,
            groupId: sg.groupId,
            effectiveDate: sg.subGroupEffectiveDate,
            terminationDate: sg.subGroupTerminationDate,
            groupDetails: 'View Details',
            subGroups: []
          }
        }

        groups[sg.groupCk].subGroups.push(sg);
      });
      return groups;
    },

    // maps to findFirstGroupByCk
    findFirstGroupByCk(groupCk, groups) {
      groups = groups || this.computedSelfGroupsArray
      return groups.find(g => g.groupCk === groupCk)
    },

    // maps to findFirstSubGroupByCk 
    findFirstSubGroupByCk(subGroupCk, subGroups) {
      subGroups = subGroups || this.computedSelfSubGroupAccess
      return subGroups.find(g => g.subGroupCk === subGroupCk)
    },

    /**
     * 
     * @deprecated as of Group Selector
     */
    subGroups(groupIdContext, groups) {
      groups = groups || this.computedSelfSubGroupAccess

      let subGroups = groups.map(g => {
        return {
          subGroupName: g.subGroupName,
          subGroupCk: g.subGroupCk,
          subGroupId: g.subGroupId,
          effectiveDate: g.subGroupEffectiveDate,
          terminationDate: g.subGroupTerminationDate,
          groupDetails: 'View Details',
          groupName: g.groupName,
          groupCk: g.groupCk,
          groupId: g.groupId,
          access: g.access
        }
      })

      if (!groupIdContext) {
        return subGroups
      }

      return subGroups.filter(sg => sg.groupId === groupIdContext)
    },
    /**
     * 
     * @deprecated as of Group Selector
     * @param {string} groupIdContext 
     * @param {array} groups 
     * @returns 
     */
    // maps to: subGroupsForDropdown
    subGroupOptions(groupIdContext, groups) {
      return this.subGroups(groupIdContext, groups).map(g => {
        return {
          value: g.subGroupCk,
          text: g.subGroupName
        }
      })
    }
  }
}
